/* istanbul ignore file */
import axios from 'axios';
import qs from 'querystring';
import { CONFIG } from 'utils/config';

axios.defaults.baseURL = CONFIG().baseUrl + 'v1/';
axios.defaults.paramsSerializer = (params) => {
  return qs.stringify(params);
};
